import React from 'react';
import styled from '@emotion/styled';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, List, ListItem, ListItemText, Chip, Box } from '@mui/material';
import { useHasPermission } from '../utils/permissionUtils';

const StyledList = styled(List)(({ theme }) => ({
    maxHeight: 320,
    overflowY: 'auto',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    marginTop: theme.spacing(1),
}));

const ItemRow = styled(ListItem)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(1),
}));

const HeaderBox = styled(Box)(({ theme }) => ({
    marginBottom: theme.spacing(1),
}));

const BoardGateWarningDialog = ({ open, gate, onClose, onBypass, bypassLabel = 'Complete anyway' }) => {
    const hasPermission = useHasPermission();
    const canBypass = hasPermission('canBypassBlockers');

    if (!gate) {
        return (
            <Dialog open={open} onClose={onClose} maxWidth="xs">
                <DialogTitle>Action Blocked</DialogTitle>
                <DialogContent>
                    <Typography>This action is currently blocked.</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>Cancel</Button>
                </DialogActions>
            </Dialog>
        );
    }

    const items = Array.isArray(gate.blockers) ? gate.blockers : Array.isArray(gate.incompleteItems) ? gate.incompleteItems : [];
    const isBlockerGate = Array.isArray(gate.blockers);
    const title = gate.title || (isBlockerGate ? 'Blocked by other tasks' : 'Board not clean');

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent dividers>
                <HeaderBox>
                    <Typography variant="body2">{gate.message}</Typography>
                </HeaderBox>
                {items.length > 0 && (
                    <StyledList disablePadding>
                        {items.map((item) => (
                            <ItemRow key={item?._id || item} divider>
                                <ListItemText primary={item?.name || String(item)} />
                                {isBlockerGate && item?.status && (
                                    <Chip size="small" label={item.status} />
                                )}
                            </ItemRow>
                        ))}
                    </StyledList>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                {canBypass && onBypass && (
                    <Button variant="contained" color="warning" onClick={onBypass}>
                        {bypassLabel}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default BoardGateWarningDialog;
